import { useSelectorWithReplayMode } from '@hooks/useSelectorWithReplayMode';
import { selectAutomatonSectionByName } from '@redux/situation/monitoring.selectors';

import { AutomatonSectionInfoData, InfoComponentProps } from '@/types/popup.types';

import AutomatonSectionInfo from './AutomatonSectionInfo';

export default function AutomatonSectionInfoWrapper({
  featureValue,
  onClose,
  ...rest
}: Readonly<InfoComponentProps<AutomatonSectionInfoData>>) {
  const automatonSectionData = useSelectorWithReplayMode(selectAutomatonSectionByName, featureValue.sectionName);

  if (!automatonSectionData) {
    onClose();
    return null;
  }
  return (
    <AutomatonSectionInfo
      featureValue={featureValue}
      onClose={onClose}
      automatonSectionData={automatonSectionData}
      {...rest}
    />
  );
}
